<template>
  <div id="contenedor-contrato-insumos-tool-bar">
    <v-toolbar flat color="transparent">
      <v-spacer></v-spacer>
      <custom-button
        v-if="mixValidaScopesActions(1)"
        label="Nuevo"
        iconText="mdi-plus"
        tipo="agregar"
        @click="nuevoInsumo">
      </custom-button>
    </v-toolbar>
  </div>
</template>

<script>
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'ContratoInsumosToolBar',
  components: {
    CustomButton,
  },
  data() {
    return {};
  },
  methods: {
    nuevoInsumo() {
      this.$emit('nuevoInsumo');
    },
  },
};
</script>

<style lang="scss">

</style>
